import {
  FETCH_FREEZEEXEMPT_FAILURE,
  FETCH_FREEZEEXEMPT_REQUEST,
  FETCH_FREEZEEXEMPT_SUCCESS,
  SAVE_FREEZEEXEMPT_FAILURE,
  SAVE_FREEZEEXEMPT_REQUEST,
  SAVE_FREEZEEXEMPT_SUCCESS
} from "../types";

// The canonical list lives on the denormalized factor client (sourced
// from FactoringJSONSerializer.freeze_exempt_contract_types) and is
// read via getFreezeExemptContractTypes. This reducer only tracks the
// load/save spinner flags; save success re-fetches the profile to
// refresh the canonical list.

export default (state, action) => {
  switch (action.type) {
    case FETCH_FREEZEEXEMPT_REQUEST:
      return { ...state, freezeExemptLoading: true };
    case FETCH_FREEZEEXEMPT_SUCCESS:
    case FETCH_FREEZEEXEMPT_FAILURE:
      return { ...state, freezeExemptLoading: false };
    case SAVE_FREEZEEXEMPT_REQUEST:
      return { ...state, freezeExemptSaving: true };
    case SAVE_FREEZEEXEMPT_SUCCESS:
    case SAVE_FREEZEEXEMPT_FAILURE:
      return { ...state, freezeExemptSaving: false };
    default:
      return state;
  }
};
